<template>
    <v-app>

      <v-main v-if="loading">
        <v-container style="min-height: 500px" class="d-flex flex-column justify-center align-center">
          <v-progress-circular
              :size="70"
              :width="7"
              :color="$store.state.achievement.side_color"
              indeterminate
          ></v-progress-circular>
        </v-container>
      </v-main>

      <v-main v-if="!loading && isPortfolioUserEmpty">
        <v-container style="min-height: 500px" class="d-flex flex-column justify-center align-center">
          <v-alert
            border="right"
            colored-border
            type="error"`
            elevation="2"
          >
            Ошибка загрузки портфолио, обратитесь к тех. поддержке или попробуйте зайти позже.
          </v-alert>
        </v-container>
      </v-main>
        <v-main v-if="!loading && !isPortfolioUserEmpty" class="transition-swing">
          <v-container fluid>
            <title-card/>
          </v-container>
          <v-container fluid>
            <main-card></main-card>
          </v-container>
          <errors-alert/>
          <the-achievement-edit-dialog/>
        </v-main>
    </v-app>
</template>

<script>
import TitleCard from "./Cards/TitleCard";
import MainCard from "./Cards/MainCard";
import {mapActions, mapState} from "vuex";
import ErrorsAlert from "./Errors/ErrorsAlert.vue";
import _ from "lodash";


const TheAchievementEditDialog = () => import("./Dialogs/TheAchievementEditDialog.vue");

export default {
  name: "portfolio",

  components: {
    TitleCard,
    TheAchievementEditDialog,
    MainCard,
    ErrorsAlert,
  },

  data() {
    return {
      response: {},
      loading: true,
    }
  },

  mounted() {
    this.fetchPortfolioUser();
  },

  computed: {
    ...mapState({
      portfolioPerson: state => state.portfolio.portfolioPerson,
    }),

    isPortfolioUserEmpty() {
      return _.isEmpty(this.portfolioPerson);
    },
  },

  methods: {
    ...mapActions({
      getPortfolioPerson: "portfolio/getPortfolioPerson",
      addError: 'error_portfolio/addError',
    }),

    async fetchPortfolioUser() {
      await this.getPortfolioPerson();
      this.loading = false;
    },
  },

}
</script>

<style>
  .side-color {
    background: #00796b;
  }

  .v-application--wrap {
    min-height: 0vh !important;
  }
</style>